import { Component, OnInit } from '@angular/core';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { ContactRequest } from '../../service/contacto/ContactRequest';
import { ToastrService } from 'ngx-toastr';
import { ContactService } from 'src/app/service/contacto/contact.service';

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.scss']
})
export class ContactoComponent implements OnInit {
  isFormVisible: boolean = false;
  isMobile: boolean = false;
  isVisible: boolean = true;
  mensajeError:string;
  email:string;
  message:string;

  constructor(
    private utilitarioService:UtilitarioService,
    private contactService:ContactService,
    private toastr:ToastrService,
  ) {}

  ngOnInit(): void {
    // console.log("ngOnInit"+this.utilitarioService.contactoVisible);
    
    this.isMobile = window.innerWidth <= 768;

    // Siempre mostrar el ícono cuando la página se carga
    if (this.utilitarioService.contactoVisible)
      this.isVisible = true;
    else
      this.isVisible = false;
  }

  toggleForm(): void {
    this.isFormVisible = !this.isFormVisible;
  }

  sendMessage(formData: { email: string; message: string }): void {
    // console.log('Mensaje enviado:', formData);
    this.email=formData.email;
    this.message=formData.message;
    this.enviarMail();
    this.isFormVisible = false; // Ocultar el formulario después de enviar
  }

  openWhatsApp(): void {
    const phone = '998732529';
    const message = 'Tengo una consulta sobre el Archivo Histórico del Diario Oficial El Peruano:\n\nConsulta: ';
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank');
  }

  hideIcon(): void {
    this.isVisible = false;  // Ocultar el ícono flotante durante la navegación
    this.utilitarioService.contactoVisible=false;
    this.isFormVisible = false;
  }

  showIcon(): void {
    this.isVisible = true;  // Mostrar el ícono flotante si el usuario lo ocultó
  }


  enviarMail(){
      if (!this.email || !this.email.trim()) {
        this.showWarning("Por favor, complete todos los campos antes de enviar.");
        return;
      }
      let contactRequest:ContactRequest;
      contactRequest = new ContactRequest();
      contactRequest.email=this.email;
      contactRequest.message=this.message;
      // console.log("go");
      this.contactService.enviarContacto(contactRequest).subscribe(data=>{
        if(data.response.codeResponse=="0000"){
          // console.log("exito");
          this.mensajeError="Hemos recibido con éxito su contacto del correo "+this.email;
        }else{
          // console.log("falla");
          this.mensajeError="Error al enviar correo";
          //this.showWarning(data.response.response);
        }
      })
    }
  
    showSuccess(mensaje,usuario) {
      this.toastr.success(mensaje);
    }
    showWarning(mensaje) {
      this.toastr.warning(mensaje);
    }
  

}
